import moment from "moment";
import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-6">{moment().year()} © RoverIsland.</div>
            <div className="col-sm-6">
              <div className="text-sm-end d-none d-sm-block">
                Crafted with <i className="mdi mdi-heart text-danger" />
                by&nbsp;
                <a
                  href="https://www.websouls.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  WebSouls
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
